export default "__VITE_ASSET__0d314d81__"